module.exports = __webpack_public_path__ + "img/Notes.2aeb903d.gif";